<template>
    <Card :bordered="false" class="border-radius-0" :key="data.useForm.modelRef?.id">
        <Form :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <Tabs v-if="data.isLoadDefaultFormDone" v-model:activeKey="data.tabKey" type="card">
            <TabPane key="SamplingAnalysisInfo" :tab="$t('views.request.samplingAnalysisInfo.products')" :forceRender="true">
                <SamplingAnalysisInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        dataKey="refSamplingAnalysisTemp"
                        :isLoading="isLoading"
                ></SamplingAnalysisInfoForm>
            </TabPane>
            <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                <AttachmentForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        dataKey="refSamplingAnalysisTemp"
                        :isLoading="isLoading"
                ></AttachmentForm>
            </TabPane>
            <TabPane key="Remark" v-if='data.userInfo?.refDepartment' :tab="$t('views.remark.text')" :forceRender="true">
                <RemarkInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        :isLoading="isLoading"
                ></RemarkInfoForm>
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
    import { Card, Form, Tabs } from "ant-design-vue";
    import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
    import { useRoute } from "vue-router";
    import { state as stateApp } from "../../../../../app.logic";
    import { createFormTitle, initForm, isLoading, onClickModalOk, state } from "./request.logic";

    export default defineComponent({
        components: {
            Card,
            Form,
            Tabs,
            TabPane: Tabs.TabPane,
            TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
            AttachmentForm: defineAsyncComponent(() => import("../../../storage-location/request/attachment/AttachmentForm")),
            SamplingAnalysisInfoForm: defineAsyncComponent(() => import("./sampling-analysis-info/SamplingAnalysisInfoForm")),
            RemarkInfoForm: defineAsyncComponent(() => import("../../../remark/RemarkInfoForm")),
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            routerPrefix: { default: "sampling-analysiss" },
            viewOnly: { default: false },
            form: {},
            setAppPageHeader: { default: true },
            visibleChangeLog: { default: true },
            requestTypeKeys: { default: ["1"] },
            forceDefault: { default: false },
        },
        setup(props) {
            // eslint-disable-next-line vue/no-mutating-props
            const route = useRoute();
            const id = props.form ? props.form.id : route.params?.id;
            const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [], sendReceive: false });
            const refs = reactive({ form: null });
            initForm({ props, data, refs, route });
            const callOnClickModalOk = () => onClickModalOk({ data, refs });
            const title = computed(() => createFormTitle({ props, data }));
            return {
                props,
                data,
                refs,
                state,
                title,
                isLoading,
                callOnClickModalOk
            };
        }
    });
</script>
